import React from 'react'
import styled from 'styled-components'
import { Flex, Box } from 'rebass'
import RouterContractedModal from '../RouterContractedModal'
import HeaderContractedOmniSearchModal from '../HeaderContractedOmniSearchModal'
import RouterAccount from '../RouterAccount'
import { connect } from 'react-redux'
import HeaderLogo from '../HeaderLogo'
import { setGlobalNumber } from '../../state/phone-number/actions'
import { array, number, object, bool } from 'prop-types'

const HeaderWrapper = styled(Flex)`
  line-height: 1;
  position: relative;
  z-index: 103;
`
const MobileMenu = styled(Box)`
  position: relative;
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  z-index: 4;
  background-color: white;
  border-bottom: 1px ${(props) => props.theme.colors.grey_light_op30} solid;
  overflow: hidden;
`

const LogoWrapper = styled(Box)`
  min-width: 33.3333%;
`

const MobileMenuFlex = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`

class HeaderContracted extends React.PureComponent {
  componentDidMount() {
    this.props.setGlobalNumber({
      phoneNumber: this.props.calltracksNumber
    })
  }

  render() {
    const { sections, subSections, max, brands, isCars, isVans } = this.props

    return (
      <HeaderWrapper flexWrap="wrap">
        <LogoWrapper width={[4 / 12]}>
          <HeaderLogo location="/" />
        </LogoWrapper>
        <MobileMenu width={[8 / 12]} alignContent="center" alignItems="center">
          <MobileMenuFlex>
            {/* <HeaderContractedDealershipsModal
              phoneNumber={phoneNumber}
              brands={brands}
            /> */}
            <HeaderContractedOmniSearchModal minimal />
            <RouterAccount nofavouritesicon favourites={4} />
            <RouterContractedModal
              sections={sections}
              subSections={subSections}
              max={max}
              brands={brands}
              isCars={isCars}
              isVans={isVans}
            />
          </MobileMenuFlex>
        </MobileMenu>
      </HeaderWrapper>
    )
  }
}

HeaderContracted.defaultProps = {
  sections: [],
  subSections: [],
  max: 3,
  brands: [],
  phoneNumber: {},
  isVans: bool,
  isCars: bool
}

HeaderContracted.propTypes = {
  sections: array,
  subSections: array,
  max: number,
  brands: array,
  phoneNumber: object
}

const mapDispatchToProps = (dispatch) => ({
  setGlobalNumber: (settings) => dispatch(setGlobalNumber(settings))
})

export default connect(
  (state) => ({ phoneNumber: state.phoneNumber }),
  mapDispatchToProps
)(HeaderContracted)
